export default class NextId {
  public lastId = 0;

  private static instance: NextId;

  public static getInstance() {
    if (NextId.instance) {
      return NextId.instance;
    }
    NextId.instance = new NextId();
    return NextId.instance;
  }
}
